import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tabs: {}
};

const obligationSlice = createSlice({
  name: "obligation",
  initialState,
  reducers: {
    saveObligationData: (state, action) => {
      const { tabId, data, tab, disburseTab  } = action.payload;
      state.tabs[tabId] = { ...data, tab, disburseTab }; 
    },
    clearObligationData: (state) => {
      state.data = null;
    },
  },
});

export const { saveObligationData, clearObligationData } = obligationSlice.actions;
export default obligationSlice.reducer;
